// extracted by mini-css-extract-plugin
export var smallFeaturedArticle = "smallFeaturedArticle-module--smallFeaturedArticle--fyYsb";
export var articleDetails = "smallFeaturedArticle-module--articleDetails--xVB7z";
export var relatedChallenge = "smallFeaturedArticle-module--relatedChallenge--D28sS";
export var category = "smallFeaturedArticle-module--category--r8Hlp";
export var author = "smallFeaturedArticle-module--author--EbQVr";
export var title = "smallFeaturedArticle-module--title--qA6gO";
export var angle = "smallFeaturedArticle-module--angle--bwrkT";
export var image = "smallFeaturedArticle-module--image--WntHr";
export var slideUp = "smallFeaturedArticle-module--slideUp--ISO-5";
export var slideUpLarge = "smallFeaturedArticle-module--slideUpLarge--8dR+M";